import React, { useCallback } from 'react';

import { Tags, TagsAlignment, TagsItem } from 'wix-ui-tpa';

import { selectMessages, selectOption } from '@/features';
import { useAppDispatch, useParametricSelector } from '@/store';

export const MessageOptions: React.FC<{
  messageId: string;
  options: string[];
}> = ({ messageId, options }) => {
  const dispatch = useAppDispatch();
  const selectedOption = useParametricSelector(
    selectMessages.makeSelectedOptionSelector,
    messageId,
  );
  const handleOptionClick = useCallback(
    (option: string) => {
      dispatch(
        selectOption({
          answerTo: messageId,
          option,
        }),
      );
    },
    [dispatch, messageId],
  );
  const tagsItems = options.map<TagsItem>((option) => ({
    title: option,
    value: option,
    checked: selectedOption === option,
    disabled: !!selectedOption,
  }));

  return (
    <Tags
      items={tagsItems}
      onClick={(item) => handleOptionClick(item.value)}
      alignment={TagsAlignment.left}
    />
  );
};
